import Vue from "vue"

export default {
  config: (
    state,
    {
      productType,
      tosPath,
      trialDays,
      countryOptions,
      regionsByCountry,
      isIosAppPurchase,
      defaultPaymentMethod,
      b2bTrailEnds
    }
  ) => {
    Vue.set(state, "productType", productType)
    Vue.set(state, "defaultPaymentMethod", defaultPaymentMethod)
    Vue.set(state, "tosPath", tosPath)
    Vue.set(state, "trialDays", trialDays)
    Vue.set(state, "countryOptions", countryOptions)
    Vue.set(state, "regionsByCountry", regionsByCountry)
    Vue.set(state, "isIosAppPurchase", isIosAppPurchase)
    Vue.set(state, "b2bTrailEnds", b2bTrailEnds)
  },
  defaultPaymentMethod: (state, defaultPaymentMethod) => {
    Vue.set(state, "defaultPaymentMethod", defaultPaymentMethod)
  },
  plan: (state, payload = {}) => {
    Vue.set(state, "plan", payload)
  },
  error: (state, payload) => {
    state.error = payload
  },
  loading: (state, payload) => {
    state.loading = payload
  },
  sending: (state, payload) => {
    state.sending = payload
  },
  coupon: (state, payload) => {
    Vue.set(state, "coupon", {
      ...state.coupon,
      ...payload
    })
  },
  email: (state, payload) => {
    Vue.set(state, "email", {
      ...state.email,
      value: payload
    })
  },
  emailError: (state, payload) => {
    Vue.set(state, "email", {
      ...state.email,
      error: payload
    })
  },
  isStandalone: (state, payload) => {
    Vue.set(state, "isStandalone", payload)
  },
  zip: (state, payload) => {
    Vue.set(state, "zip", {
      ...state.zip,
      ...payload
    })
  },
  street1: (state, payload) => {
    state.street1 = payload
  },
  street2: (state, payload) => {
    state.street2 = payload
  },
  city: (state, payload) => {
    state.city = payload
  },
  vatNumber: (state, payload) => {
    Vue.set(state, "vatNumber", {
      ...state.vatNumber,
      ...payload
    })
  },
  countryCode: (state, payload) => {
    state.countryCode = payload
  },
  region: (state, payload) => {
    state.region = payload
  },
  giftcard: (state, payload) => {
    Vue.set(state, "giftcard", {
      ...state.giftcard,
      ...payload
    })
  },
  tax: (state, { amount, region } = {}) => {
    Vue.set(state, "tax", {
      amount,
      region
    })
  },
  selectedPaymentMethod: (state, payload) => {
    state.selectedPaymentMethod = payload
  }
}
